module.exports = "https://static.wmbcdn.com/uniweb/images/be75eba319a433fcd6a7959853c32d14.svg";